import { REQUEST_STATE, SET_STATE_KEY } from './constants'

export const getStateSets = types => Object.values(types).map(type => createStateSet(type))

export const createStateSet = (type, { cancelSource, promise } = {}) => {
  const set = {
    type,
    stateKey: `${type}State`,
    modifiedKey: `${type}Modified`,
    statusCodeKey: `${type}StatusCode`,
    messageKey: `${type}Message`,
    dataKey: `${type}Data`,
  }
  if (cancelSource) {
    set.cancelSourceKey = `${type}CancelSource`
  }
  if (promise) {
    set.promiseKey = `${type}Promise`
  }
  return set
}

export const createStateFromSet = set => {
  // console.log(set)
  return {
    [`${SET_STATE_KEY}_${set.type}`]: {
      [set.stateKey]: REQUEST_STATE.STATE_INITIAL,
      [set.modifiedKey]: undefined,
      [set.statusCodeKey]: undefined,
      [set.messageKey]: undefined,
      [set.dataKey]: undefined,
    },
  }
}

export const getState = stateSets => {
  return stateSets.reduce(
    (result, stateSet) => {
      return {
        ...result,
        ...createStateFromSet(stateSet),
      }
    },
    {
      [`${SET_STATE_KEY}`]: stateSets,
    },
  )
}
